import gql from 'graphql-tag';

export const BlockedAccessRestrictionsQuery = gql`
	query BlockedAccessRestrictionsQuery(
		$accessType: ResourceAccessType!
		$contentId: Long!
		$subjects: [BlockedAccessSubjectInput]!
	) {
		blockedAccessRestrictions(accessType: $accessType, contentId: $contentId, subjects: $subjects) {
			blockedAccessRestrictionSummary {
				subject {
					subjectId
					subjectType
				}
				restrictedResources {
					resourceId
					resourceTitle
					resourceLink {
						base
						webUi
					}
					requiredAccessType
					resourceType
				}
			}
			blockedAccessEmpowerment {
				subjectId
				isCurrentUserEmpowered
			}
			canFixRestrictionsForAllSubjects
		}
	}
`;
